import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6344c326"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "offer-details" }
const _hoisted_2 = {
  key: 0,
  class: "h3 mt-0 mb-3"
}
const _hoisted_3 = {
  key: 1,
  class: "bg-light rounded py-4 pr-3 mb-5"
}
const _hoisted_4 = { class: "services-list" }
const _hoisted_5 = {
  key: 0,
  class: "text-muted"
}
const _hoisted_6 = {
  key: 2,
  class: "h3 mt-0 mb-4"
}
const _hoisted_7 = { class: "table estimate-pricing-table" }
const _hoisted_8 = { scope: "row" }
const _hoisted_9 = {
  key: 0,
  class: "text-lyft"
}
const _hoisted_10 = { scope: "row" }
const _hoisted_11 = {
  key: 1,
  class: "text-primary"
}
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { scope: "row" }, "Openbay+ Savings:", -1))
const _hoisted_13 = { class: "row pt-3 mb-4" }
const _hoisted_14 = { class: "col-sm-6 order-sm-2 text-right mb-3 mb-sm-0" }
const _hoisted_15 = { class: "text-primary font-weight-bolder" }
const _hoisted_16 = { class: "col-sm-6 d-flex" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "far fa-xs fa-asterisk text-primary mt-1 mr-2" }, null, -1))
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "small" }, " This estimate is based on the information submitted. Estimates may be subject to change upon further inspection of the vehicle. ", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DetailsLineItem = _resolveComponent("DetailsLineItem")!
  const _component_icon = _resolveComponent("icon")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    (_ctx.showHeaders)
      ? (_openBlock(), _createElementBlock("h2", _hoisted_2, "Services"))
      : _createCommentVNode("", true),
    (!_ctx.hideServices)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createElementVNode("ul", _hoisted_4, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.services, (service) => {
              return (_openBlock(), _createElementBlock("li", {
                key: service.id
              }, [
                _createTextVNode(_toDisplayString(service.name) + " ", 1),
                (service.notes)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_5, _toDisplayString(service.notes), 1))
                  : _createCommentVNode("", true)
              ]))
            }), 128))
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.showHeaders)
      ? (_openBlock(), _createElementBlock("h2", _hoisted_6, _toDisplayString(_ctx.detailsTitle), 1))
      : _createCommentVNode("", true),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.offer.offerLineItems, (lineItem) => {
      return (_openBlock(), _createBlock(_component_DetailsLineItem, {
        key: lineItem.id,
        "line-item": lineItem
      }, null, 8, ["line-item"]))
    }), 128)),
    _createElementVNode("table", _hoisted_7, [
      _createElementVNode("tbody", null, [
        _createElementVNode("tr", null, [
          _createElementVNode("td", _hoisted_8, _toDisplayString(_ctx.subTotalLabel) + ":", 1),
          _createElementVNode("td", null, _toDisplayString(_ctx.monetize(_ctx.subTotal, 'cents')), 1)
        ]),
        (_ctx.hasLyftDiscount && _ctx.isLyftUser)
          ? (_openBlock(), _createElementBlock("tr", _hoisted_9, [
              _createElementVNode("td", _hoisted_10, [
                _createVNode(_component_icon, { icon: ['fab', 'lyft'] }),
                _createTextVNode(" Driver Savings:")
              ]),
              _createElementVNode("td", null, "-" + _toDisplayString(_ctx.monetize(_ctx.offer.voLyftDiscount, 'dollars')), 1)
            ]))
          : _createCommentVNode("", true),
        (_ctx.discountsApplied && _ctx.hasSubscription)
          ? (_openBlock(), _createElementBlock("tr", _hoisted_11, [
              _hoisted_12,
              _createElementVNode("td", null, "-" + _toDisplayString(_ctx.monetize(_ctx.discountsApplied, 'cents')), 1)
            ]))
          : _createCommentVNode("", true)
      ])
    ]),
    _createElementVNode("div", _hoisted_13, [
      _createElementVNode("div", _hoisted_14, [
        _createElementVNode("h4", null, [
          _createTextVNode(" Total Price: "),
          _createElementVNode("span", _hoisted_15, _toDisplayString(_ctx.priceTotal), 1)
        ])
      ]),
      _createElementVNode("div", _hoisted_16, [
        _createVNode(_component_icon, {
          icon: ['fal', 'asterisk'],
          size: "xs",
          class: "text-primary mt-1 mr-2"
        }),
        _hoisted_17,
        _hoisted_18
      ])
    ])
  ]))
}